export default __webpack_public_path__ + "static/media/Filter.2eb0e742.svg";